var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('modal', [_c('div', {
    staticClass: "mod_pop"
  }, [_c('div', {
    staticClass: "pop_main"
  }, [_c('div', {
    staticClass: "pop_main-hd"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "shape1 dot1"
  }), _c('div', {
    staticClass: "shape2 dot2"
  }), _c('div', {
    staticClass: "shape3 dot3"
  }), _c('div', {
    staticClass: "shape4 dot4"
  }), _c('div', {
    staticClass: "shape1 dot5"
  }), _c('div', {
    staticClass: "shape1 dot6"
  }), _c('div', {
    staticClass: "shape3 dot7"
  }), _c('div', {
    staticClass: "shape4 dot8"
  })]), _c('div', {
    staticClass: "hd_inner"
  }, [_c('i', {
    staticClass: "icon_suc"
  }), _c('span', [_vm._v("预约成功")])])]), _c('div', {
    staticClass: "pop_main-bd"
  }, [_c('div', {
    staticClass: "desc_txt"
  }, [_c('p', [_vm._v("关注腾讯视频VIP公众号")]), _c('p', [_vm._v("提醒通知不错过")])]), _c('div', {
    staticClass: "qrcode"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://puui.qpic.cn/vupload/0/20190411_1554980524272_qymbqr9ixof.png/0"
    }
  })]), _c('div', {
    staticClass: "desc_txt"
  }, [_vm._v("\n            截图或长按保存图片后，扫码关注\n          ")]), _c('label', {
    staticClass: "agree"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.notMindMe,
      expression: "notMindMe"
    }],
    staticClass: "agree_checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notMindMe) ? _vm._i(_vm.notMindMe, null) > -1 : _vm.notMindMe
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.notMindMe,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.notMindMe = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.notMindMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.notMindMe = $$c;
        }
      }
    }
  }), _c('i', {
    staticClass: "icon_checkbox"
  }), _c('span', {
    staticClass: "agree__text"
  }, [_vm._v("不再提醒我关注公众号")])])])]), _c('div', {
    staticClass: "pop_main-ft"
  }, [_c('div', {
    staticClass: "btn_wrap",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "btn is_link"
  }, [_vm._v("我知道了")])])])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };